import PropTypes from "prop-types";
import { get } from "lodash";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { getDepartmentSkillOptions } from "utils/constants";

const SkillDepartmentField = ({ formProps, index, excludeLabel, valueLabel }) => {
  const selectionPath = `skills.${index}.departmentSelection`;
  const excludePath = `skills.${index}.departmentExclude`;

  return (
    <div className="d-flex align--start gap-16">
      <div className="flex--grow-1">
        <Select
          mode="multiple"
          options={getDepartmentSkillOptions()}
          placeholder={valueLabel}
          label={valueLabel}
          value={get(formProps.values, selectionPath, []) || []}
          onChange={(value) => formProps.setFieldValue(selectionPath, value)}
        />
      </div>
      <Input
        type="checkbox"
        label={excludeLabel}
        checked={!!get(formProps.values, excludePath, false)}
        onChange={(checked) => formProps.setFieldValue(excludePath, checked)}
      />
    </div>
  );
};

SkillDepartmentField.propTypes = {
  formProps: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  excludeLabel: PropTypes.string.isRequired,
  valueLabel: PropTypes.string.isRequired,
};

export default SkillDepartmentField;
